import Fiesta from './Componentes/AssetsCard/omar-lopez-T6zu4jFhVwg-unsplash.jpg';
import Reunion from './Componentes/AssetsCard/annie-spratt-hCb3lIB8L8E-unsplash.jpg';
import Bodas from './Componentes//AssetsCard/al-elmes-ULHxWq8reao-unsplash.jpg';
import Convenciones from './Componentes/AssetsCard/campaign-creators-gMsnXqILjp4-unsplash.jpg';


const cardData = [
    {
        src: Fiesta,
        title: 'Eventos',
        backColor: '#4D6113',
    },
    {
        src: Reunion,
        title: 'Reuniones',
        backColor: '#9A4E05'
    },
    {
        src: Bodas,
        title: 'Bodas',
        backColor: '#E1CA9B',
    },
    {
        src: Convenciones,
        title: 'Convenciones',
        backColor: '#005795',
    },
];
export default cardData